// FilterableHeaderWithPopover.jsx
import React, { useState } from 'react';
import { useListContext } from 'react-admin';
import TableCell from '@mui/material/TableCell';
import IconButton from '@mui/material/IconButton';
import Popover from '@mui/material/Popover';
import TextField from '@mui/material/TextField';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

const FilterableHeaderWithPopover = ({ source, label }) => {
    const { filterValues, setFilters } = useListContext();
    const [anchorEl, setAnchorEl] = useState(null);
    const [inputValue, setInputValue] = useState(filterValues[source] || '');

    const open = Boolean(anchorEl);

    const applyFilter = newValue => {
        setFilters(
          { ...filterValues, [source]: newValue },
          {}
        );
    };

    const handleClick = event => {
        if (!open) {
            // 開く直前に最新のフィルター値を反映
            setInputValue(filterValues[source] || '');
        }
        setAnchorEl(open ? null : event.currentTarget);
    };

    const handleClose = () => {
        // ポップオーバーを閉じる前にフィルターを適用
        applyFilter(inputValue);
        setAnchorEl(null);
    };

    const handleKeyDown = e => {
        if (e.key === 'Enter') {
            // Enterでもポップオーバーを閉じる
            handleClose();
        }
    };

    return (
      <>
        <TableCell
          component="div"
          style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
          onClick={handleClick}
        >
          <span style={{ flex: 1 }}>{label}</span>
          <IconButton size="small" disableRipple style={{ padding: 4 }}>
            <ArrowDropDownIcon fontSize="small" />
          </IconButton>
        </TableCell>
        <Popover
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}    // ← ポップオーバーが閉じられたときにも呼ばれる
          anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
          transformOrigin={{ vertical: 'top', horizontal: 'left' }}
          disableRestoreFocus
        >
          <div style={{ padding: 8 }}>
            <TextField
              label={label}
              value={inputValue}
              onChange={e => setInputValue(e.target.value)}
              onKeyDown={handleKeyDown}
              variant="standard"
              size="small"
              autoFocus
            />
          </div>
        </Popover>
      </>
    );
};

export default FilterableHeaderWithPopover;
